import apiClient from '../../../api/client';
import type {
  CobradorCercaClienteRow,
  CobradorCercaResponse,
  CobradorClienteRow,
  CobradorClienteContextResponse,
  CobradorDashboardResponse,
  Paginated,
  SeccionCobrador,
} from '@aid/shared';

export type {
  CobradorCercaClienteRow,
  CobradorClienteRow,
  CobradorCercaResponse,
  CobradorDashboardResponse,
  SeccionCobrador,
};

export interface QueryCobradorClientes {
  seccion: SeccionCobrador;
  limit: number;
  offset: number;
}

export async function getCobradorDashboard(): Promise<CobradorDashboardResponse> {
  const { data } = await apiClient.get<CobradorDashboardResponse>('/cobrador/dashboard');
  return data;
}

export async function getCobradorClienteContext(
  idCliente: number,
): Promise<CobradorClienteContextResponse> {
  const { data } = await apiClient.get<CobradorClienteContextResponse>(
    `/cobrador/clientes/${idCliente}/contexto`,
  );
  return data;
}

export async function getCobradorClientes(
  params: QueryCobradorClientes,
): Promise<Paginated<CobradorClienteRow>> {
  const { data } = await apiClient.get<Paginated<CobradorClienteRow>>('/cobrador/clientes', {
    params,
  });
  return data;
}

/**
 * Tab `Cerca`: snapshot de posición del cobrador + radio de búsqueda.
 * Contrato del CERC-01 (`QueryCobradorCercaDtoSchema`): solo se consultan
 * las secciones `hoy`/`pendientes` con saldo pendiente positivo; los
 * clientes sin coordenadas quedan fuera del resultado.
 */
export interface QueryCobradorCerca {
  latitud: number;
  longitud: number;
  radioMetros: number;
  limit?: number;
}

export async function getCobradorCerca(params: QueryCobradorCerca): Promise<CobradorCercaResponse> {
  const { data } = await apiClient.get<CobradorCercaResponse>('/cobrador/cerca', {
    params,
  });
  return data;
}
